import { render, staticRenderFns } from "./IbGuidedTour.vue?vue&type=template&id=61574d4a"
import script from "./IbGuidedTour.vue?vue&type=script&lang=js"
export * from "./IbGuidedTour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports